.root {
  align-items: center;
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  display: flex;
  font-size: 14px;
  gap: 8px;
  padding: 8px 12px;
  transition: border-color 0.15s;

  &:focus-within {
    border-color: var(--color-focus);
    box-shadow: 0 0 0 2px var(--color-focus);
  }
}

.root-is-disabled {
  background: var(--color-secondary);
  cursor: not-allowed;
  opacity: 0.6;
}

.icon {
  color: var(--color-muted);
  flex-shrink: 0;
}

.field {
  background: transparent;
  border: none;
  outline: none;
  width: 100%;

  &::placeholder {
    color: var(--color-placeholder);
  }

  &:disabled {
    cursor: not-allowed;
  }

  &:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px var(--color-background) inset;
    -webkit-text-fill-color: var(--color-foreground);
  }
}
